import { IAjaxCallerTs } from "../../../../../Scripts/Default/AjaxCallerTsImplementation/AjaxCaller";
import { ICallbackResult } from "../../../../../Scripts/Default/AjaxCallerTsImplementation/CallBackObject";
import { IAccountInfoViewModel} from "../../../../../Scripts/inpulse/I4UViewModels";

export class MyInformationApiService {
    constructor(
        private client: IAjaxCallerTs,
    ) {
    }

    GetAccountInfoFull(): ICallbackResult {
        var method = "GetAccountInfoFull";
        return this.client.execute(method, null);
    }

    GeAccountInfoLinkedUsers(): ICallbackResult {
        var method = "GeAccountInfoLinkedUsers";
        return this.client.execute(method, null);
    }

    GetMyAccountInfo(): ICallbackResult {
        var method = "GetMyAccountInfo";
        return this.client.execute(method, null);
    }

    GetEnerityCustomerLinks(): ICallbackResult {
        var method = "GetEnerityCustomerLinks";
        return this.client.execute(method, null);
    }

}




/*Check ticket: https://jira.solteq.com/browse/SQJEPTY-113
//TODO: add AccountInfoViewModel here!
//TODO: Get atleast GeAccountInfoLinkedUsers and pass these values to modal
//Make modal that list usernames all linked customer with full permission to all usermappings for UserName and make links to
// https://localhost:44330/eServices/MyInformation/AccountInfo#tab-asiakastiedot-1 <-- make logic to open right "Yhteystiedot-tab that belongs to selected customer" 
// make db change to Userinfoes  [AskMarketingPermissionOnLogin] Boolean
// ask from consumer customers if AskMarketingPermissionOnLogin=true and show modal that lists linkedcustomers (don't show this if logged user is ADMIN)
// Check ln.367 in Inpulse4Utilities.Web\Areas\eServices\Views\MyInformation\JE\_MyCustomersPartial.cshtml

    if (item.MyAccessLevels == null ||
    item.MyAccessLevels[WebModule.Contacts.ToString()] != UserMappingAccessLevelEnum.Full ||
    item.MyAccessLevels[WebModule.Contracts.ToString()] != UserMappingAccessLevelEnum.Full ||
    item.MyAccessLevels[WebModule.CustomerInformation.ToString()] != UserMappingAccessLevelEnum.Full ||
    item.MyAccessLevels[WebModule.Invoicing.ToString()] != UserMappingAccessLevelEnum.Full ||
    item.MyAccessLevels[WebModule.Messages.ToString()] != UserMappingAccessLevelEnum.Full ||
    item.MyAccessLevels[WebModule.Outages.ToString()] != UserMappingAccessLevelEnum.Full ||
    item.MyAccessLevels[WebModule.Reports.ToString()] != UserMappingAccessLevelEnum.Full ||
    item.MyAccessLevels[WebModule.ReadingEntry.ToString()] != UserMappingAccessLevelEnum.Full)
    
// Make logic to update value in Userinfoes  [AskMarketingPermissionOnLogin] Boolean if user has set the value
    */